module.exports = __webpack_public_path__ + "static/media/connector_suspendedEV.27d95854.png";